import { OperatorInterface } from "utils"

import FooterBC from "assets/images/BCconsumer-footer.svg"

export const BICYCODE_NAME = "Bicycode®"
export const BICYCODE_ID = "BC"
export const BICYCODE_SUBDOMAIN = "bicycode"
export const BICYCODE_CONTACT_EMAIL = "contact@bicycode.eu"
export const BICYCODE_ASSO_EMAIL = "asso@bicycode.eu"

export const bicycodeConfiguration: OperatorInterface = 
    {
		name: "Bicycode",
		id: BICYCODE_ID,
		subDomain: BICYCODE_SUBDOMAIN,
    url: "moncompte.bicycode.eu",
		folderName: "bicycode",
    cguUrl: "https://legal.o-code.co/bike/Bicycode/Owner/CGU/fr/CGU_Bicycode_20220101.pdf",
    legalNoticeUrl: "https://legal.o-code.co/bike/Bicycode/Owner/ML/fr/MentionsLegales_Bicycode_20220101.pdf",
	  privacyPolicyUrl: "https://legal.o-code.co/bike/Bicycode/Owner/PDC/fr/PolitiqueDeConfidentialite_Bicycode_20220101.pdf",
		faqAccordionLength: 7,
		theme: {
            primaryColor: "#1B1464",
            primaryColorHover: "#110a54",
            secondaryColor: "#FF4121",
            formBackgroundColor: "#E3E2ED",
            insaleBike: "#514B89",
            insaleBikeHover: "#1B1464",
            secondaryColorLighten: "#F6AEA1",
            secondaryColorHover: "#FF4121",
            placeholderColor: "#1B1464",

            fontFamilyHeading: "'MADE Evolve Sans', 'Open Sans', Arial, sans-serif",
            footerBackground: `url(${FooterBC}) bottom no-repeat #fff`
		  }
    }